import { Banner } from '../../../components/Banner/Banner'
import { BTN_TXT } from '../../../constants'

export const BankAccountError = () => {
  const handleAddBankAccount = () => undefined

  return (
    <Banner.Error
      text="Please create bank account to initiate a payment."
      className="mb-24"
      button={[
        {
          buttonText: BTN_TXT.ADD_BANK_ACCOUNT,
          onButtonClick: handleAddBankAccount
        }
      ]}
    />
  )
}
